import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { NotificationManager } from "react-notifications";
import { showLoader, hideLoader } from '../../../store/common/slice';
import { updateLegacyPayments } from '../../../store/buildings/actions';
import { constants } from '../../../common/constants/constants';
import Input from '../../../common/simple/input';
import { StyledUpdateFeesModal } from "../yearly_by_months/yearlyByMonth.styled";

const ManagerUpdateApartmentModal = ({ row, buildingID, year, selectedYear, show, onHide, setUpdatePayment }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [updateBtnDisabled, setUpdateBtnDisabled] = useState(true);
    const [monthlyFeesValues, setMonthlyFeesValues] = useState({});
    const [amountPaidValues, setAmountPaidValues] = useState({});

    useEffect(() => {
        let disabled = false;
        for (const month of Object.values(constants.MonthsToText)) {
            if (+monthlyFeesValues[month] < +amountPaidValues[month]) {
                disabled = true;
            }
        }
        setUpdateBtnDisabled(disabled);
    }, [amountPaidValues, monthlyFeesValues]);

    useEffect(() => {
        let initialState = {};
        let initialStatePaid = {};

        if (row != null) {
            for (const month of Object.values(constants.MonthsToText)){
                initialState[month] = row[month]?.total?.value || '';
                initialStatePaid[month] = row[month]?.paid?.value || '';
            }
            setMonthlyFeesValues(initialState);
            setAmountPaidValues(initialStatePaid);
        }
    }, [row]);

    const onMonthlyFeeInputChange = e => {
        setMonthlyFeesValues({
            ...monthlyFeesValues,
            [e.target.name]: e.target.value
        })
    };

    const onAmountPaidInputChange = e => {
        setAmountPaidValues({
            ...amountPaidValues,
            [e.target.name]: e.target.value
        })
    };

    function onUpdateManagerFees() {
        setUpdatePayment(true);
    }

    const updateManagerFees = async () => {
        dispatch(showLoader());
        const backendMapping = constants.APIContract.legacyPayments.months;
        const apartmentUpdatedFees = Object.values(constants.MonthsToText).map(month => {
            const monthName = backendMapping[month];
            const monthlyFee = parseFloat(monthlyFeesValues?.[month] ?? null);
            const amountPaid = parseFloat(amountPaidValues?.[month] ?? null);
            let shouldSendRowToServer = !isNaN(monthlyFee);
            if (shouldSendRowToServer) {
                let row = { year: year };
                const paidForMonth = isNaN(amountPaid) ? 0 : amountPaid;
                row[monthName] = `${monthlyFee - paidForMonth} / ${monthlyFee}`;
                return row
            }
            return undefined;
        }).filter(row => row != null && row.year != null);

        const requestPayload = { payments: apartmentUpdatedFees };
        const { apartmentNumber } = row;
        const { payload } = await dispatch(updateLegacyPayments({ buildingID, apartmentNumber, requestPayload }));
        const success = payload && payload.result && payload.result.errors && payload.result.errors.length === 0;
        dispatch(hideLoader());

        if (success) {
            NotificationManager.success(t('reports.legacyPaymentsUpdated'), '', 5000);
            onUpdateManagerFees();
        } else NotificationManager.error(t('reports.legacyPaymentsFailed', {errors: JSON.stringify(payload.errors)}), '', 5000);
    }

    return (
        <StyledUpdateFeesModal
            show={show}
            centered
            onHide={onHide}
            size='lg'
        >
            <Modal.Header><h2>{t('reports.yearlyByMonths.mainTitle', { apartmentName: row?.apartmentName ?? '', year: selectedYear?.value ?? '' })}</h2></Modal.Header>
            <Modal.Body>
                <div className='gridWrapper'>
                    <div></div>
                    <h4 className='header'>{t('reports.yearlyByMonths.monthlyFee')}</h4>
                    <h4 className='header'>{t('reports.yearlyByMonths.amountPaid')}</h4>
                </div>
                <div>
                    {Object.values(constants.MonthsToText).map((month, i) => {
                        return(
                            <div key={month} className='gridWrapper monthWrapper'>
                                <div className='header'>{t(`common.months.${i+1}`)}</div>
                                <Input
                                    value={monthlyFeesValues[month]}
                                    name={month}
                                    onChange={onMonthlyFeeInputChange}
                                />
                                <Input
                                    value={amountPaidValues[month]}
                                    name={month}
                                    onChange={onAmountPaidInputChange}
                                />
                            </div>
                        )
                    })}
                </div>
                <button
                    className='bllink-button'
                    onClick={updateManagerFees}
                    disabled={updateBtnDisabled}
                >
                    {t('searchPayments.btns.update')}
                </button>
            </Modal.Body>
        </StyledUpdateFeesModal>
    )
}

export default ManagerUpdateApartmentModal;
